module.exports = __webpack_public_path__ + "static/media/blue-bg-img.163cbd1a.svg";